import { Box, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { DataGrid } from '@mui/x-data-grid';

const Title = styled(Typography)`
  margin: 1%;
  font-size: 4rem !important;
  margin: 1%;
`;

const Header = styled('div')`
    display: flex;
    justify-content: center;
    margin: 1%;
  `;

const Content = styled('div')`
  display: flex;
  justify-content: center;
  margin: 1%;
  height: 400px;
`;

const Image = styled('img')`
  padding: 1%;
`

const NotaFiscalStatusIcon = styled(Box) <{ backgroundColor: string }>`
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${(props) => props.backgroundColor};
`;

const BotaoDelete = styled(IconButton)`
  margin-left: auto;
` as any;

const StyledDataGrid = styled(DataGrid)`
  &.MuiDataGrid-root .MuiDataGrid-columnHeader:focus,
  &.MuiDataGrid-root .MuiDataGrid-cell:focus {
    outline: none;
  }
`;

export { Title, Header, Content, Image, BotaoDelete, StyledDataGrid, NotaFiscalStatusIcon };